import React, { useState, useRef, useEffect } from "react";
import LeafletMinimap from "./LeafletMinimap";
import "./draggableMinimap.css";

function DraggableLeafletMinimap({ images, activeMarker, onMarkerClick }) {
  const wrapperRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ top: 145, right: 20 });
  const [isLocked, setIsLocked] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const offset = useRef({ x: 0, y: 0 });

  const handleMouseDown = e => {
    if (isLocked) return;
    setIsDragging(true);
    offset.current = {
      x: e.clientX - wrapperRef.current.getBoundingClientRect().left,
      y: e.clientY - wrapperRef.current.getBoundingClientRect().top
    };
  };

  useEffect(() => {
    if (!isDragging) return;
    const handleMouseMove = e => {
      if (!isDragging || isLocked) return;
      const newLeft = e.clientX - offset.current.x;
      const newTop = e.clientY - offset.current.y;
      setPosition({ top: newTop, left: newLeft });
    };
    const handleMouseUp = () => {
      if (!isLocked) setIsDragging(false);
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, isLocked, offset]);

  if (!isVisible) {
    return (
      <button className="map-toggle-btn" onClick={() => setIsVisible(true)}>
        <span role="img" aria-label="mapa">
          🗺️
        </span>{" "}
        Mostrar Mapa
      </button>
    );
  }

  return (
    <div
      ref={wrapperRef}
      className="draggable-minimap"
      onMouseDown={handleMouseDown}
      style={{ top: position.top, left: position.left, right: "auto" }}
    >
      <div className="minimap-controls">
        <button onClick={() => setIsLocked(v => !v)} title="Travar posição">
          {isLocked ? "🔒" : "🔓"}
        </button>
        <button onClick={() => setIsVisible(false)} title="Esconder">
          <span role="img" aria-label="lupa">
            ❌
          </span>
        </button>
      </div>
      <LeafletMinimap
        images={images}
        activeMarker={activeMarker}
        onMarkerClick={onMarkerClick}
      />
    </div>
  );
}

export default DraggableLeafletMinimap;
